
import { useState,useEffect } from "react"
import Cim from "../Cim"

const LenyiloTipus=({kivalasztott})=>{
    const [adatok,setAdatok]=useState([])
    const [tolt,setTolt]=useState(true)
    const [hiba,setHiba]=useState(false)

    

    useEffect(()=>{
        const leToltes=async ()=>{
        try{
            const response=await fetch(Cim.Cim+"/tipus")
            const data=await response.json()
            //alert(JSON.stringify(data))
            //console.log(data)
            if (response.ok)
                {
                    setAdatok(data)
                    setTolt(false)}
            else 
                {
                    setHiba(true)
                    setTolt(false)
                }
            }
        catch (error){
            console.log(error)
            setHiba(true)
        }
        
    }

        leToltes()
    },[kivalasztott])

    if (tolt)
        return (
            <div style={{textAlign:"center", fontSize: "20px"}}>Adatok betöltése folyamatban...</div>
                )
    else if (hiba)
        return (
            <div style={{  fontSize: "20px",color:"red"}}>Hiba</div>
                )

    else return (
        <div>
            <select onChange={(e)=>  kivalasztott(e.target.value)      }>
                {adatok.map((elem,index)=>(
                    <option key={index} value={elem.tipus_id}> {elem.tipus_nev} </option>
                ))}
            </select>
        </div>
    )
}
export default LenyiloTipus
